import './okta.scss';

import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import encryptor from '../../../lib/utils/encryptor';
import { getHashValue } from '../../../lib/utils/qol';
import { authActions } from '../../../store/slices/auth';
import { getTempConnection } from '../../../store/utils/authStorage';

const OktaPage = () => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const redirect = useCallback(() => {
        history.replace({ pathname: location.state?.from?.pathname || '/' });
    }, [history, location.state]);

    useEffect(() => {
        if (isAuthenticated) {
            redirect();
        }
    }, [isAuthenticated, redirect]);

    useEffect(() => {
        if (!isAuthenticated) {
            const tempConnection = getTempConnection();
            const connection = {
                name: tempConnection.name,
                graphqlEndpoint: encryptor.decrypt(tempConnection.graphqlEndpoint),
                oktaServer: encryptor.decrypt(tempConnection.oktaServer),
                userpoolClientId: encryptor.decrypt(tempConnection.userpoolClientId),
                authType: 'okta'
            };

            const idToken = getHashValue('id_token', location.hash);
            const accessToken = getHashValue('access_token', location.hash);

            dispatch(authActions.CONNECTED_VIA_OKTA({
                oktaConnection: connection,
                idToken,
                accessToken,
            }));
        }
    }, [dispatch, location, isAuthenticated]);

    return (
        <div>
            <span>Loading...</span>
        </div>
    );
};


export default OktaPage;